const FolderIcon = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path
        d="M22 19V9a2 2 0 0 0-2-2h-6.764a2 2 0 0 1-1.789-1.106l-.894-1.788A2 2 0 0 0 8.763 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z"
        fill="none"
      />
    </svg>
  );
};

export default FolderIcon;
